import {getEnv} from "src/utils/getEnv"

export const SUPPORT_URL = getEnv(
    "VITE_SUPPORT_URL",
    "https://odyssey-services.atlassian.net/servicedesk/customer/portal/5"
)
export const DOC_API_URL = getEnv("VITE_DOC_API_URL", "https://docgraphapi.docoon.com/")
export const LEGAL_TERMS_URL = getEnv("VITE_LEGAL_TERMS_URL", "https://docoon.com/mentions-legales/")
export const USER_GUIDE_URL = getEnv("VITE_USER_GUIDE_URL")
